<template>
  <div class="payment">
    <div class="payment__bill">
      <div class="input-group">
        <label>
          施工金額
          <div class="subLabel">（税込）</div>
        </label>
        <input type="text" inputmode="numeric" pattern="[0-9]*"
               onkeypress='return /[\d]/.test(event.key)'
               @blur='inputMoney'
               :value='moneyDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label>内、消費税
          <div class="discount-text">{{ taxRateDisplay }}%</div>
        </label>
        <input type="text" inputmode="numeric" pattern="[0-9]*" readonly='true'
               onkeypress='return /[\d]/.test(event.key)'
               @focus='typingTax = true'
               @blur='typingTax = false'
               @input='inputTax'
               :value='typingTax ? tax:taxDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label style='color: red'>口コミ割
        </label>
        <input type="text" inputmode="numeric" pattern="[0-9]*" readonly='true'
               style='color: red'
               onkeypress='return /[\d]/.test(event.key)'
               :value='discountReviewed'>
        <span>円</span>
      </div>
      <div class="input-group" v-if="use_purchase">
        <label style='color: red'>買取額</label>
        <input type="text" readonly="true"
               style='color: red'
               :value='purchaseDisplay'>
        <span>円</span>
      </div>
      <div class="input-group">
        <label v-bind:style="{color: minusTextColorTotal}">ご請求金額</label>
        <input type="text" readonly="true" :value='totalDisplay' v-bind:style="{color: minusTextColorTotal}">
        <span>円</span>
      </div>
    </div>

    <div class="reload-area">
      <button type='button' @click='getData' class='btn'>再読み込み</button>
    </div>

    <div v-if="is_payed" class="payed__methods">
      <p>お支払い済み</p>
      <div class="actions">
        <button type='button' @click='receipt' class='btn'>領収書</button>
      </div>
    </div>
    <div v-else class="payment__methods">
      <p>お支払い方法</p>
      <div class="actions">
        <div v-if="stripe_publishable_key">
          <div class="p-modal" :class="{'is-open': isQrcodeModalActive}">
            <img :src="image_qr_code_src">
            <p>上記QRコードを読み取ってください。<br>お客様の端末でPayが完了したら<br>「確認」をタップしてください。</p>
            <p style="color:red;">現在、ApplePayはご利用になれません。ご了承ください。</p>
            <button type='button' @click='stripeQrcodePayDone' class='btn'>確認</button>
            <button type='button' @click='stripeQrcodePayClose' class='btn'>閉じる</button>
          </div>
          <button type='button' @click='stripeQrcodePay' class='btn credit'>GooglePay</button>

          <div class="p-modal" :class="{'is-open': isCardModalActive}">
            <p>クレジットカードでお支払い</p>
            <div id="card-element" style="margin: 1em auto; max-width: 400px;"></div>
            <button @click="submitCardPayment" class="btn credit" :disabled="isProcessingCardPayment">{{ isProcessingCardPayment ? '処理中…' : '支払う' }}</button>
            <button @click="isCardModalActive = false" class="btn" :disabled="isProcessingCardPayment">{{ isProcessingCardPayment ? '処理中…' : '閉じる' }}</button>
          </div>
          <button type="button" @click="isCardModalActive = true" class="btn credit">ｸﾚｼﾞｯﾄ/ﾃﾞﾋﾞｯﾄ</button>
        </div>
        <button v-else type='button' @click='submit(1)' class='btn credit'>クレジット</button>
        <button type='button' @click='submit(2)' class='btn'>現金</button>
      </div>
    </div>
  </div>
</template>
<script>
const Currency = new Intl.NumberFormat('ja-JP', {style: 'currency', currency: 'JPY'});
const toCurrency = function (value) {
  return Currency.format(value).replace(/[^\d,-]/g, '')
}
const stripNonDigit = function (value) {
  return Number.parseInt(value.toString().replace(/\D/g, ''))
}

// <-- stirpe
import {
  loadStripe
} from '@stripe/stripe-js';
// -- stripe --

export default {
  name: 'Payment',
  props: ['order'],
  components: {},
  data: function () {
    return {
      tax: 0,
      money: 0,
      taxRate: 0,

      discount: 0,
      discountRate: 0,
      discountTemporary: 0,

      use_purchase: false,
      purchase: 0,

      discountReviewed: 0,

      typingTax: false,
      typingDiscount: false,

      // stripe payments
      stripeImage: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      stripeName: '作業費用お支払い',
      stripeDescription: '',
      stripeCurrency: 'jpy',
      stripeLocale: 'ja',
      stripePanelLabel: '支払',

      pay_token: '',
      pay_kind: '',
      pay_email: '',

      isQrcodeModalActive: false,
      isCardModalActive: false,
      stripe_qrcode_pay_my_token: '',
      image_qr_code_src: '',

      is_payed: false,
      is_finished: false,
      stripe_publishable_key: '',
      isProcessingCardPayment: false,

      stripe: null,
      elements: null,
      card: null,
    }
  },
  computed: {
    moneyDisplay: function () {
      return toCurrency(this.money)
    },
    taxDisplay: function () {
      return toCurrency(this.tax)
    },
    taxRateDisplay: function () {
      return (this.taxRate !== 0) ? (this.taxRate * 100) : 0
    },
    discountDisplay: function () {
      return (this.discount ? '- ' : '') + toCurrency(this.discount)
    },
    discountTemporaryDisplay: function () {
      return toCurrency(this.discountTemporary)
    },
    total: function () {
      let total = this.money - this.discount - (this.purchase || 0) - this.discountReviewed;
      if (total < 0) {
        total = 0
      }
      return total
    },
    totalDisplay: function () {
      return toCurrency(this.total)
    },
    purchaseDisplay: function () {
      return (this.purchase > 0 ? '- ' : '') + toCurrency(this.purchase)
    },
    minusTextColorTotal: function () {
      return this.total < 0 ? 'red' : 'black'
    }
  },
  methods: {
    inputMoney: function ($event) {
      this.money = Number.parseInt(stripNonDigit($event.target.value)) || 0;
      this.calc();
    },
    inputTax: function ($event) {
      this.tax = Number.parseInt(stripNonDigit($event.target.value)) || 0;
    },
    inputDiscount: function ($event) {
      this.discount = Number.parseInt(stripNonDigit($event.target.value)) || 0;
    },
    calc: function () {
      this.tax = this.money - Math.floor((this.money / Math.round((1 + this.taxRate) * 100)) * 100);
      this.discount = this.calcDiscount();
      if (this.order.order.survey_flag === undefined || Number.parseInt(this.order.order.survey_flag) === 0) {
        this.discountTemporary = this.calcDiscountTemporary();
      } else {
        this.discountTemporary = 0;
      }
      if (this.order.info_steps[4].already_reviewed && this.order.info_steps[4].discount_reviewed_price > 0) {
        this.discountReviewed = this.order.info_steps[4].discount_reviewed_price
      }
    },
    calcDiscount: function () {
      let discount = Math.floor((this.money) * this.discountRate);
      if (this.order.info_steps[4].apply_max_price) {
        if (discount > this.order.info_steps[4].apply_max_price_survey) {
          return this.order.info_steps[4].apply_max_price_survey
        }
      }
      return discount
    },
    calcDiscountTemporary: function () {
      let discount = Math.floor((this.money) * (Number.parseFloat(this.order.discount_rate) || 0));
      if (this.order.info_steps[4].apply_max_price) {
        if (discount > this.order.info_steps[4].apply_max_price_survey) {
          return this.order.info_steps[4].apply_max_price_survey
        }
      }
      return discount
    },
    surveyDiscountText: function() {
      if (this.order === null) {
        return ''
      }
      let text = '-' + (Number.parseFloat(this.order.discount_rate) * 100.0) + '%'
      if (this.order.info_steps[4].apply_max_price) {
        text += ' ※最大' + this.order.info_steps[4].apply_max_price_survey + '円まで'
      }
      return text
    },
    getData: function() {
      this.$api.getOrderSteps(this.$route.params.id)
          .then((res)=> {
            if (this.order) {
              this.order.info_steps = res.data.data.info_steps;
              this.calc()
            }
          })
          .finally(() => {
            this.checkData()
          })
    },
    checkData: function() {
      if (this.order) {
        if (!(this.order.info_steps &&
            this.order.info_steps[0].status == 1 &&
            this.order.info_steps[1].status == 1 &&
            this.order.info_steps[2].status == 1) && !this.$route.params['finishCampaign']) {
          this.$$.alert({
            message: "全ての作業が完了していないため、<br/>-3％になりません。",
            action: () => {
              setTimeout(this.checkOrderReview, 100)
            },
            cancelAction: () => {
              this.$router.push({name: 'orderSteps'})
            },
            cancelText: '戻る',
          })
        } else {
          this.checkOrderReview()
        }
      }
    },

    // <-- stripeCheckout --
    // (Removed vue-stripe-checkout logic)
    // -- stripeCheckout -->

    // <-- stripeQrcodePay --
    async stripeQrcodePay() {
      // QRコードを取得
      this.$api.postStripeMobilePay(this.$route.params.id, this.total)
          .then((res) => {
            // 画面表示
            this.stripe_qrcode_pay_my_token = res.data.data.my_token;
            this.image_qr_code_src = "data:image/png;base64," + res.data.data.image_qr_code_src;
            this.isQrcodeModalActive = true;
          })
          .catch(() => {
            alert('GooglePay/ApplePayをご利用になれません。');
          })
    },
    stripeQrcodePayClose() { //
      alert('支払い処理がキャンセルされました。');
      this.isQrcodeModalActive = false;
    },
    stripeQrcodePayDone() { //
      this.$api.getStripeMobilePay(this.$route.params.id, this.stripe_qrcode_pay_my_token)
          .then((res) => {
            this.isQrcodeModalActive = false;
            this.pay_token = res.data.data.pay_token;
            this.pay_email = res.data.data.pay_email;
            this.pay_kind = 'stripe';
            this.submit(1);
          })
          .catch(() => {
            this.isQrcodeModalActive = false;
          })
    },
    // -- stripeQrcodePay -->


    submit: function (type) {
      this.$$.bill = {
        pay_type: type === 1 ? 1 : 2,
        amount: this.money - this.tax,
        tax: this.tax,
        discount: this.discount,
        discount_reviewed: this.discountReviewed,
        total: this.total,
        pay_token: this.pay_token,
        pay_email: this.pay_email,
        pay_kind: this.pay_kind,
      };
      if (this.order.info_steps[4].invoice_amount > 0) {
        this.$$.alert({
          message: '紹介料調整がリセットされます。もう一度、調整希望をお願いします',
          actionText: 'はい',
          cancelText: 'いいえ',
          action: () => {
            this.$$.invoice_reset = 1;
            this.$router.push({name: 'afterworksignature', params: this.$route.params});
          },
          cancelAction: () => {
            this.$router.push({name: 'orderSteps', params: this.$route.params});
          }
        })
      } else {
        this.$router.push({name: 'afterworksignature', params: this.$route.params});
      }
    },

    receipt: function () {
      this.$router.push({name: 'receipt', params: this.$route.params});
    },

    checkOrderReview: function () {
      if (!this.order.info_steps[4].already_reviewed && this.order.info_steps[4].discount_reviewed_price > 0 && !this.$route.params['finishCampaign']) {
        this.$$.alert({
          action: () => {
            this.$router.push({name: 'paymentOrderReview'})
          },
          message: '<div style="font-size: 80%;"><div style="margin: 0 0 10px;">' +
              '========================<br>' +
              '500円割引のご提案<br>' +
              '========================<br>' +
              '</div>' +
              '<div style="text-align: left; line-height: 1.25em;"><p>口コミ投稿で<b>本日の作業代金が500円割引</b>されます。</p>\n' +
              '<p>わずか5分で終ります。<br />\n' +
              '個人情報は100％保護。</p>\n' +
              '<p>口コミ登録しますか？</p>\n</div></div>',
          cancelAction: () => {
            if (this.order.info_steps[0].flag_campaign) {
              this.$router.push({
                name:   'campaigninfo',
                params: this.$route.params
              });
            }

          },
          actionText: 'はい',
          cancelText: 'いいえ'
        })
      }
    },

    async submitCardPayment() {
      if (this.isProcessingCardPayment) return;
      this.isProcessingCardPayment = true;
      // (card element is already configured with hidePostalCode in mounted)
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
        billing_details: {
          // 任意: 名前・メール等
        },
      });

      if (error) {
        alert(error.message);
        this.isProcessingCardPayment = false;
        return;
      }

      // サーバーで PaymentIntent を作って confirm する
      const res = await this.$api.postStripePaymentIntent(
          this.$route.params.id,
          {
            payment_method: paymentMethod.id,
            amount: this.total, // 金額（サーバー側でもチェックしてね）
          }
      );

      if (res.data.data.already_paid) {
        this.$$.alert({
          message: "すでに支払い済みです。",
          action: () => {
            this.pay_token = '';
            this.pay_kind = 'stripe';
            this.pay_email = ''; // 任意
            this.submit(1)
          },
        });
      } else {
        const clientSecret = res.data.data.client_secret;
        const result = await this.stripe.confirmCardPayment(clientSecret);
        if (result.error) {
          alert(result.error.message);
          this.isProcessingCardPayment = false;
        } else if (result.paymentIntent.status === 'succeeded') {
          this.pay_token = '';
          this.pay_kind = 'stripe';
          this.pay_email = ''; // 任意
          this.submit(1); // サーバーに通知
        }
      }
    },
  },
  created: function () {
    if (this.order) {
      this.amount = this.total;
      this.is_payed = this.order.info_steps[4].is_payed;
      this.is_finished = this.order.info_steps[4].status === 1;
      this.stripe_publishable_key = this.order.info_steps[4].stripe_publishable_key

      // (Removed Vue.use(VueStripeCheckout, ...) for vue-stripe-checkout)

      let moneyDefault = Number.parseInt(this.order.info_steps[4].amount_default)
      let moneyPaid = Number.parseInt(this.order.info_steps[4].amount_paid)
      let willDiscount = Number.parseInt(this.order.order.survey_flag) || 0

      this.taxRate
          = Number.parseFloat(this.order.tax_rate);
      this.discountRate
          = (Number.parseFloat(this.order.discount_rate) || 0) * willDiscount;

      if (moneyPaid) {
        this.money = moneyPaid
      } else {
        this.money = moneyDefault
      }

      this.use_purchase = this.order.info_steps[3].use_purchase;
      this.purchase = this.order.info_steps[3].amount;

      this.calc();

      if (this.is_payed && !this.is_finished) {
        this.$$.alert({
          message: "支払済みですが、まだ作業は完了していません。<br/>" +
              "完了するには、作業完了のサインをお願いします。",
          action: () => {
            this.pay_token = '';
            this.pay_kind = 'stripe';
            this.pay_email = ''; // 任意
            this.submit(1)
          },
          cancelAction: () => {
            this.$router.push({name: 'orderSteps'})
          },
          cancelText: '戻る',
        })
      }
    } else {
      this.$router.push({name: 'orderSteps', params: this.$route.params})
    }
  },
  async mounted() {
    this.$$.context({
      previous: 'トップへ',
      title: "ID:" + this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
    this.getData();
    this.stripe = await loadStripe(this.stripe_publishable_key);
    // Create Stripe Elements with options (disable postal code)
    this.elements = this.stripe.elements({
      locale: 'ja',
    });
    this.card = this.elements.create('card', {
      hidePostalCode: true
    });
    this.card.mount('#card-element');
  }
}
</script>
<style lang='scss'>
.payed__methods {
  padding: 32px 0;
  text-align: center;

  p {
    margin-bottom: .5em;
    font-size: 1.25em;
  }

  .actions {
    .btn {
      white-space: nowrap;
      font-size: 1.25em;
      margin: .5em .75em;
      min-width: 7em;
    }

    .credit {
      background: #28a7f1;
    }
  }
}

.p-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  background-color: #FFF;

  &.is-open {
    visibility: visible;
    opacity: 1;
    z-index: 100;
  }

  img {
    padding-top: 30px;
    padding-bottom: 30px;
    width: 300px;
  }
}

.payment {
  padding: 1.5em 0;

  &__bill {
    .input-group {
      margin-bottom: 1.5em;

      label {
        width: 8em;
        flex-grow: 0;
        flex-shrink: 0;
        text-align: center;
      }

      input {
        font-size: 2em;
        padding: .25em;
        line-height: 1;
        height: auto;
        text-align: right;
      }

      span {
        font-size: 1.5em;
        padding: 0 .25em;
      }

      &:last-child {
        margin-top: 2.5em;
      }
    }

    .discount-info-row {
      justify-content: flex-end;
    }

    .discount-info {
      margin-left: 8px;
      color: red;
    }

    .discount-money {
      font-weight: bold;
    }

    .btn-sm {
      font-size: small;
      padding: 4px;
      margin: 10px;
    }
  }

  &__methods {
    padding: 16px 0;
    text-align: center;

    p {
      margin-bottom: .5em;
      font-size: 1.25em;
    }

    .actions {
      .btn {
        white-space: nowrap;
        font-size: 1.25em;
        margin: .5em .75em;
        min-width: 7em;
      }

      .credit {
        background: #28a7f1;
      }
    }

  }

  .discount-text {
    font-size: .65em;
  }

  .subLabel {
    font-size: .65em;
  }

  .reload-area {
    margin: 0 10px;
    text-align: right;
  }
}
</style>
